import {NgModule} from '@angular/core';
import {ApModule} from './ap/ap.module';
import {SpModule} from './sp/sp.module';
import {FeaturePlanningRoutingModule} from './feature-planning.routing.module';

@NgModule({
    exports: [
        ApModule,
        SpModule,
    ],
    imports: [
        ApModule,
        SpModule,
        FeaturePlanningRoutingModule
    ]
})
export class FeaturePlanningModule {
}
